__turbopack_context__.v({
  "counter": "CompareIconButton-module__2vkAgW__counter",
  "counterHidden": "CompareIconButton-module__2vkAgW__counterHidden",
  "counterNumber": "CompareIconButton-module__2vkAgW__counterNumber",
  "counterNumberHidden": "CompareIconButton-module__2vkAgW__counterNumberHidden",
  "counterNumberVisible": "CompareIconButton-module__2vkAgW__counterNumberVisible",
  "counterVisible": "CompareIconButton-module__2vkAgW__counterVisible",
  "iconWrapper": "CompareIconButton-module__2vkAgW__iconWrapper",
  "rectangle": "CompareIconButton-module__2vkAgW__rectangle",
  "rectangleAnimateIn": "CompareIconButton-module__2vkAgW__rectangleAnimateIn",
  "rectangleAnimateOut": "CompareIconButton-module__2vkAgW__rectangleAnimateOut",
  "showHeader": "CompareIconButton-module__2vkAgW__showHeader",
});
